import styled from 'styled-components';
import audioOff from 'assets/icons/ic-callkit-audio-off.webp';
import audioOn from 'assets/icons/ic-callkit-audio-on.webp';
import callEnd from 'assets/icons/ic-callkit-end.webp';
import screenShare from 'assets/icons/ic-callkit-screen-share.webp';
import stopVideo from 'assets/icons/ic-callkit-video-off.webp';
import startVideo from 'assets/icons/ic-callkit-video-on.webp';
import ButtonCircle from '../../../components/atoms/ButtonCircle';

export const CallButton = styled(ButtonCircle)`
  margin: 0 10px;
  background-repeat: no-repeat;
  background-position: center center;
`;

export const DialButton = styled(ButtonCircle)`
  margin: 0 10px;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid var(--purple-300);
`;

export const VideoDialButton = styled(DialButton)`
  background-image: url(/icons/ic-video-thumbnail-purple.svg);
`;

export const AudioDialButton = styled(DialButton)`
  background-color: var(--purple-300);
  background-image: url(/icons/ic-callkit-audio-20.svg);
`;

export const VideoCallAcceptButton = styled(CallButton)`
  background-color: #2eba9f;
  background-image: url(/icons/icon-call-video.svg);
  &:hover {
    background-color: #007a7a;
  }
`;

export const AudioCallAcceptButton = styled(CallButton)`
  background-color: #2eba9f;
  background-image: url(/icons/ic-callkit-audio.svg);
  &:hover {
    background-color: #007a7a;
  }
`;

export const UnmuteButton = styled(CallButton)`
  background-color: #ea4335;
  background-size: 20px;
  background-image: url(${audioOff});
  &:hover {
    /* background-color: rgba(168, 168, 168, 0.5); */
  }
`;

export const MuteButton = styled(CallButton)`
  background-color: #3c4043;
  background-size: 17px;
  background-image: url(${audioOn});
  &:hover {
    background-color: rgba(168, 168, 168, 0.5);
  }
`;

export const StopVideoButton = styled(CallButton)`
  background-color: #ea4335;
  background-size: 22px;
  background-image: url(${stopVideo});
  &:hover {
    /* background-color: rgba(168, 168, 168, 0.5); */
  }
`;

export const StartVideoButton = styled(CallButton)`
  background-color: #3c4043;
  background-size: 21px;
  background-image: url(${startVideo});
  &:hover {
    background-color: rgba(168, 168, 168, 0.5);
  }
`;

const ButtonCircle2 = styled.div`
  min-width: 70px;
  min-height: 50px;
  width: 70px;
  height: 50px;
  cursor: pointer;
  border-color: transparent;
  border-radius: 100px;
  background-color: var(--white);
`;

const CallButton2 = styled(ButtonCircle2)`
  margin: 0 10px;
  background-repeat: no-repeat;
  background-position: center center;
`;

export const EndButton = styled(CallButton2)`
  background-size: 30px;
  background-color: #ea4335;
  background-image: url(${callEnd});
  &:hover {
  }
`;

export const StartScreenShareButton = styled(CallButton)`
  background-size: 24px;
  background-color: #3c4043;
  background-image: url(${screenShare});
  text-align: center;
  &:hover {
    background-color: rgba(168, 168, 168, 0.5);
  }
`;

export const StopScreenShareButton = styled(CallButton)`
  background-size: 24px;
  background-color: #8ab4f8;
  background-image: url(${screenShare});
  text-align: center;
  &:hover {
    /* background-color: #145082; */
  }
`;
